module.exports = __webpack_public_path__ + "static/media/14.fc78dca2.jpeg";